window.anvil.block('content-grid-text-images', el => {
	const trigger = el.querySelector('.animate-trigger');
	const animate = el.querySelector('.animate');

	window.gsap.from(animate, {
		y: '100%',
		opacity: 0,
		duration: 0.8,
		ease: 'power3.out',
		scrollTrigger: {
			trigger: trigger,
			start: 'top 80%',
			end: 'bottom 80%',
			toggleActions: 'play none none none',
		}
	});

	const design_1 = el.querySelector('.design-1');

	if (design_1) {
		const image = design_1.querySelector('.main-image');

		window.gsap.from(image, {
			x: '110vw', // Start 110% of the viewport width to the right (ensures it's fully off-screen)
			rotation: index => index === 0 ? -15 : 15, // Add a subtle opposite rotation on entrance
			opacity: 0,
			duration: 1.5,
			ease: 'power4.out',
			stagger: 0.2, // Animate them one after the other with a 0.2s delay
			scrollTrigger: {
				trigger: design_1,
				start: 'top 75%', // Start the animation when the section is 75% in view
				toggleActions: 'play none none none', // Play the animation once and don't reverse
			},
			markers: true
		});
	}

	const design_2 = el.querySelector('.design-2');
	if (design_2) {
		const image_wrapper_1 = design_2.querySelector('.image_wrapper_1');
		const image_wrapper_2 = design_2.querySelector('.image_wrapper_2');

		window.gsap.from(image_wrapper_1, {
			rotation: -10,
			scrollTrigger: {
				trigger: design_2,
				start: 'top 80%',
				end: 'bottom 70%',
				scrub: 1,
			}
		});

		window.gsap.from(image_wrapper_2, {
			rotation: 15,
			scrollTrigger: {
				trigger: design_2,
				start: 'top 80%',
				end: 'bottom 70%',
				scrub: 1,
			}
		});
	}
});
